import { jsx as _jsx } from "react/jsx-runtime";
import { Router } from '@mui/icons-material';
import { ConfigItem } from './config-item';
import { PeripheralUpdateType } from 'features/device.settings.upgrade-extensions/lib';
import { FileTransfersList } from './file-transfers-list';
import { ServiceButtons } from './service-buttons';
import { UpdateButton } from './update/update-button';
import { selectDevice } from 'entities/device/lib';
import { useAppSelector, usePartialAppSelector } from 'shared/hooks/redux/hooks';
export function HeadItem(props) {
    const { is_service_view, model, hardware, firmware, device_id, optional_info, children, } = props;
    const device = usePartialAppSelector(selectDevice, device_id);
    const online = !!device?.online;
    const is_staff = useAppSelector((state) => state.account.is_staff);
    return (_jsx(ConfigItem, { is_service_view: is_service_view, online: online, serial: device?.serial, name: device?.name, model: model, hardware: hardware, firmware: firmware, memory_use: device?.memory_use_state, is_staff: is_staff, optional_info: optional_info, action_buttons: _jsx(ServiceButtons, { device_id: device_id, online: online }), update_button: _jsx(UpdateButton, { device_id: device_id, update_type: PeripheralUpdateType.Main }), icon: _jsx(Router, {}), subheader: _jsx(FileTransfersList, {}), children: children }));
}
